// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__29ylA","list":"PatternAutocomplete_list__2zllc"};